// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7a6309c9","239":"af13293b","453":"7526f366","455":"36b9ba52"}[chunkId] + ".chunk.js";
};